(() => {
  if (window.BegodeDynamicCheckout) return;

  const MAX_WAIT_MS = 4500;
  const READY_DELAY_MS = 120;

  function normalizeProvider(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function hasReadyButton(wrapper) {
    const acceleratedCheckout = wrapper.querySelector('shopify-accelerated-checkout');
    if (!acceleratedCheckout) return false;

    const slottedButton = acceleratedCheckout.querySelector('[slot="button"]');
    if (slottedButton) {
      let recommendedProvider = '';
      try {
        recommendedProvider = JSON.parse(acceleratedCheckout.getAttribute('recommended') || '{}').name || '';
      } catch (_error) {
        recommendedProvider = '';
      }

      const expectedProvider = normalizeProvider(recommendedProvider);
      const renderedProvider = normalizeProvider(slottedButton.tagName);
      if (!expectedProvider || expectedProvider === 'buyitnow') return true;
      return renderedProvider.includes(expectedProvider);
    }

    const legacyButton = acceleratedCheckout.querySelector(
      '.shopify-payment-button__button:not(.shopify-payment-button__skeleton):not([aria-hidden="true"])'
    );
    return Boolean(legacyButton);
  }

  function setPending(wrapper) {
    if (wrapper.classList.contains('begode-dynamic-checkout--pending')) return;
    wrapper.classList.add('begode-dynamic-checkout--pending');
    wrapper.classList.remove('begode-dynamic-checkout--ready');
    wrapper.setAttribute('aria-busy', 'true');
  }

  function setReady(wrapper) {
    if (wrapper.classList.contains('begode-dynamic-checkout--ready')) return;
    wrapper.classList.remove('begode-dynamic-checkout--pending');
    wrapper.classList.add('begode-dynamic-checkout--ready');
    wrapper.setAttribute('aria-busy', 'false');
  }

  function initialize(wrapper) {
    if (!wrapper || wrapper.dataset.begodeDynamicCheckoutReady === 'true') return;

    wrapper.dataset.begodeDynamicCheckoutReady = 'true';
    setPending(wrapper);

    let readyTimer = 0;
    let revealTimer = 0;

    const armFallback = () => {
      if (revealTimer) return;
      revealTimer = window.setTimeout(() => {
        revealTimer = 0;
        setReady(wrapper);
      }, MAX_WAIT_MS);
    };

    const refresh = () => {
      window.clearTimeout(readyTimer);
      if (!hasReadyButton(wrapper)) {
        setPending(wrapper);
        armFallback();
        return;
      }

      readyTimer = window.setTimeout(() => {
        window.clearTimeout(revealTimer);
        revealTimer = 0;
        setReady(wrapper);
      }, READY_DELAY_MS);
    };

    const observer = new MutationObserver(refresh);
    observer.observe(wrapper, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'disabled']
    });

    armFallback();
    refresh();
  }

  function initializeAll(root = document) {
    root.querySelectorAll('[data-begode-dynamic-checkout]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  window.BegodeDynamicCheckout = { initializeAll };
})();
